// Admin MUI v5 theme — extends `buildAdminMuiTheme()` from @findgeeks/ui-tokens
// (sub-plan 13 §13.2). Adds component-level overrides (button/table) per the
// design reference.

import { createTheme } from "@mui/material";
import { tokens, buildAdminMuiTheme } from "@findgeeks/ui-tokens";

export const theme = createTheme({
  ...buildAdminMuiTheme(),
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          borderRadius: tokens.radius.sm,
          fontWeight: 600,
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        head: {
          fontWeight: 600,
          background: tokens.colors.admin.bg,
        },
      },
    },
  },
});
